import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  CustomCheckbox,
  CustomDropdown,
  CustomPanel,
  Loading,
  PageHeader,
} from '../../../../components'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { DataTable } from 'primereact/datatable'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { getGroups } from '../../../../services/api/https/settings/group.http'
import {
  getGroupPermission,
  toggleGroupPermissions,
} from '../../../../services/api/https/system/system.http'

function PermissoesGrupoUsuario({ history, dispatch }) {
  // Vars

  // Hooks
  const [isLoading, setIsLoading] = useState(false)
  const [acoes, setAcoes] = useState([])
  const [grupos, setGrupos] = useState([])
  const [selectedGrupo, setSelectedGrupo] = useState(null)
  useEffect(() => {
    getGrupos()
  }, [])

  // Events
  const onGrupoChange = group_id => {
    const index = grupos.findIndex(g => g.value === group_id)
    if (index !== -1) {
      setSelectedGrupo(grupos[index])
      getAcoes(group_id)
    }
  }

  const onCheckboxClick = async ({ user_action_id }) => {
    try {
      const resp = await toggleGroupPermissions(selectedGrupo.value, user_action_id)
      const index = acoes.findIndex(a => a.user_action_id === user_action_id)
      if (index !== -1) {
        const nAcoes = [...acoes]
        nAcoes[index].selected = resp
        setAcoes(nAcoes)
      }
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }
  // Helpers
  const getGrupos = async () => {
    try {
      const fetchedGrupos = await getGroups()
      if (fetchedGrupos.length !== 0) {
        setGrupos(fetchedGrupos.map(g => ({ label: g.name, value: g.id })))
      }
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const getAcoes = async group_id => {
    try {
      !isLoading && setIsLoading(true)
      const fetchedActions = await getGroupPermission(group_id)
      setAcoes(fetchedActions)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoading(false)
    }
  }
  // Render
  return (
    <React.Fragment>
      <PageHeader>S.2 - Permissões Por Grupo de Usuários</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-3">
              <CustomDropdown
                label="Grupos de Usuários:"
                options={grupos}
                value={selectedGrupo ? selectedGrupo.value : ''}
                onChange={id => onGrupoChange(id)}
              />
            </div>
          </div>
          <div style={{ marginTop: 20 }}>
            {isLoading ? (
              <div className="p-grip">
                <Loading />
              </div>
            ) : acoes.length === 0 ? null : (
              <DataTable
                value={acoes}
                rowGroupMode="subheader"
                groupField="group_name"
                rowGroupHeaderTemplate={acao => acao.group_name}
                rowGroupFooterTemplate={() => {}}
              >
                <Column
                  field="selected"
                  header="#"
                  style={tableCellCentered(80)}
                  body={acao => (
                    <CustomCheckbox
                      checked={acao.selected}
                      onChange={() => onCheckboxClick(acao)}
                    />
                  )}
                />
                <Column field="user_action_id" header="Id" style={tableCellCentered(80)} />
                <Column field="action" header="Ação" />
                <Column field="show_ordem" header="Ordem" style={tableCellCentered()} />
              </DataTable>
            )}
          </div>
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

export default connect()(withRouter(PermissoesGrupoUsuario))
